/** Current signed-in user's role and client-side action checks. The real
 * authorization guarantee remains server-side. */
import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "./api-context.js";

function useAccountRole(): string | undefined {
  const api = useApiClient();
  const { data } = useQuery({
    queryKey: ["account", "role"],
    queryFn: () => api.get<{ role?: string }>("/account"),
    staleTime: 5 * 60_000,
  });
  return data?.role;
}

export function useIsViewer(): boolean {
  return useAccountRole() === "viewer";
}

export function useCanManageConnections(): boolean {
  const role = useAccountRole();
  return role === "owner" || role === "admin";
}
